const productData = [
  {
    id: 101,
    name: "Combined coat with detachable collar",
    category: "Coats",
    price: "499.00",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 132,
    images: [
      "/img/101.avif",
      "/img/101a.avif",
      "/img/101b.avif",
      "/img/101c.avif",
      "/img/101d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Soft wool-blend exterior with tonal faux-fur collar that buttons off for warmer days.",
      "Quilted satin lining and light padding provide cozy insulation without bulk.",
      "Hidden zip and snap placket maintain a polished finish while keeping wind out.",
    ],
    Features: [
      "Type: combined coat with detachable collar",
      "Closure: concealed zipper with snap buttons",
      "Care: dry clean only",
    ],
  },
  {
    id: 102,
    name: "Manteco wool coat with fur collar",
    category: "Coats",
    price: "559.00",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 84,
    images: [
      "/img/102.avif",
      "/img/102a.avif",
      "/img/102b.avif",
      "/img/102c.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Premium Manteco® recycled wool cloth with a brushed handfeel.",
      "Detachable faux-fur shawl collar adds warmth and playful volume.",
      "Straight silhouette with front darts designed for layering over knits.",
    ],
    Features: [
      "Type: wool coat with removable collar",
      "Fabric: Manteco recycled wool blend",
      "Care: professional dry clean",
    ],
  },
  {
    id: 103,
    name: "Lapels bouclé coat",
    category: "Coats",
    price: "429.00",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 91,
    images: [
      "/img/103.webp",
      "/img/103a.avif",
      "/img/103b.avif",
      "/img/103c.avif",
      "/img/103d.avif",
      "/img/103e.avif",
      "/img/103f.avif",
    ],
    size: ["100cm", "110cm", "120cm", "130cm", "140cm"],
    description: [
      "Bouclé knit surface with tonal lapel collar inspired by classic pea coats.",
      "Button-through front with interior grosgrain tape for durability.",
      "Side welt pockets lined in microfleece keep little hands warm.",
    ],
    Features: [
      "Type: bouclé coat with lapels",
      "Pockets: two front welt pockets",
      "Care: machine wash cold, line dry",
    ],
  },
  {
    id: 104,
    name: "Manteco wool coat with belt",
    category: "Coats",
    price: "579.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 65,
    images: [
      "/img/104.avif",
      "/img/104a.webp",
      "/img/104b.webp",
      "/img/104c.webp",
      "/img/104d.webp",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Longline wrap silhouette crafted in Manteco® double-faced wool.",
      "Self-fabric belt cinches the waist and can be removed for open wear.",
      "Interior seams are hand-finished for a clean, unlined construction.",
    ],
    Features: [
      "Type: belted wool coat",
      "Fabric: double-faced Manteco wool blend",
      "Care: dry clean recommended",
    ],
  },
  {
    id: 105,
    name: "Double-breasted wool coat",
    category: "Coats",
    price: "489.00",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 118,
    images: [
      "/img/105.avif",
      "/img/105a.webp",
      "/img/105b.avif",
      "/img/105c.avif",
      "/img/105d.avif",
    ],
    size: ["100cm", "110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Heritage-inspired double-breasted front with matte horn-effect buttons.",
      "Structured shoulders and tailored seams keep the coat tidy through play.",
      "Half-lined interior with contrast piping and name label for school days.",
    ],
    Features: [
      "Type: double-breasted coat",
      "Lining: partial polyester lining",
      "Care: dry clean only",
    ],
  },
  {
    id: 106,
    name: "Wool-blend micro-houndstooth coat",
    category: "Coats",
    price: "459.00",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 77,
    images: ["/img/106.avif"],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Micro-houndstooth pattern woven into a soft wool-blend cloth.",
      "Point collar and button placket mirror classic menswear tailoring.",
      "Interior hanger loop and smooth lining make on-and-off effortless.",
    ],
    Features: [
      "Type: patterned wool-blend coat",
      "Pattern: micro-houndstooth check",
      "Care: dry clean preferred",
    ],
  },
  {
    id: 107,
    name: "Handmade wool coat with belt",
    category: "Coats",
    price: "649.00",
    country: "Mangoes Kids",
    rating: 4.9,
    reviewCount: 54,
    images: [
      "/img/107.avif",
      "/img/107a.avif",
      "/img/107b.avif",
      "/img/107c.avif",
      "/img/107d.avif",
      "/img/107e.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Hand-finished seams deliver a lightweight drape with premium feel.",
      "Removable belt and hidden snap closure let kids customize the fit.",
      "Large patch pockets and back vent allow easy movement during play.",
    ],
    Features: [
      "Type: handmade belted coat",
      "Construction: hand-sewn interior seams",
      "Care: dry clean only",
    ],
  },
  {
    id: 108,
    name: "Satin dress with gathered V-neckline",
    category: "Dresses",
    price: "69.99",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 103,
    images: [
      "/img/108.mp4",
      "/img/108a.avif",
      "/img/108b.avif",
      "/img/108c.avif",
      "/img/108d.avif",
      "/img/108e.avif",
      "/img/108f.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Smooth satin fabric with a subtle luster in a rich rust hue.",
      "Deep V-neckline with delicate front ring gather detail.",
      "Sleeveless design with fine spaghetti straps.",
      "Flattering bias cut for a fluid, body-skimming drape.",
    ],
    Features: [
      "Type: satin slip dress",
      "Neckline: gathered V-neck with ring",
      "Straps: adjustable spaghetti straps",
      "Care: hand wash cold, dry flat",
    ],
  },
  {
    id: 109,
    name: "A-line linen dress",
    category: "Dresses",
    price: "79.99",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 147,
    images: ["/img/109.avif", "/img/109a.avif", "/img/109b.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Crisp and breathable white linen fabric perfect for warm days.",
      "Classic A-line silhouette that flatters and provides ease of movement.",
      "Square neckline and wide shoulder straps for a structured look.",
      "Midi length with a clean, minimalist design.",
    ],
    Features: [
      "Type: A-line dress",
      "Fabric: breathable linen blend",
      "Neckline: square neck",
      "Care: machine wash cold, line dry",
    ],
  },
  {
    id: 1010,
    name: "Halter polka dot dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.3,
    reviewCount: 96,
    images: [
      "/img/1010.avif",
      "/img/1010a.avif",
      "/img/1010b.avif",
      "/img/1010c.avif",
      "/img/1010d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Lightweight chiffon fabric featuring a playful micro polka dot print.",
      "High halter neckline with an elegant back tie closure.",
      "Smocked elastic waist for a comfortable, defining fit.",
      "Tiered, ruffled mini skirt adds flirty volume and movement.",
    ],
    Features: [
      "Type: halter mini dress",
      "Pattern: micro polka dot",
      "Waist: elastic smocking",
      "Care: hand wash cold, hang to dry",
    ],
  },
  {
    id: 1011,
    name: "Draped halter dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 112,
    images: [
      "/img/1011.avif",
      "/img/1011a.avif",
      "/img/1011b.avif",
      "/img/1011c.avif",
      "/img/1011d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Vibrant cobalt blue fabric with a textured, slightly crinkled finish.",
      "Chic halter neckline that highlights the shoulders.",
      "Sophisticated draped detailing across the bodice and waist.",
      "Fitted silhouette that accentuates the figure beautifully.",
    ],
    Features: [
      "Type: draped midi dress",
      "Neckline: halter neck",
      "Details: front draping and ruching",
      "Care: machine wash delicate, do not tumble dry",
    ],
  },
  {
    id: 1012,
    name: "Floral-print halter dress",
    category: "Dresses",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 108,
    images: [
      "/img/1012.avif",
      "/img/1012a.avif",
      "/img/1012b.avif",
      "/img/1012c.avif",
      "/img/1012d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Soft, lightweight fabric adorned with a bold purple and green floral print.",
      "Classic square neckline paired with wide, supportive straps.",
      "Fitted bodice leading into a gently flared midi-length skirt.",
      "Perfect for garden parties or vibrant summer outings.",
    ],
    Features: [
      "Type: floral midi dress",
      "Pattern: large floral print",
      "Neckline: square neck with wide straps",
      "Care: machine wash cold, iron low",
    ],
  },
  {
    id: 1013,
    name: "Polka dot balloon jeans",
    category: "Bottoms",
    price: "49.99",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 87,
    images: [
      "/img/1013.avif",
      "/img/1013a.avif",
      "/img/1013b.avif",
      "/img/1013c.avif",
      "/img/1013d.avif",
      "/img/1013e.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    description: [
      "Sturdy cotton denim in a dark brown wash with an all-over white polka dot pattern.",
      "Trendy balloon leg silhouette offering a relaxed and roomy fit.",
      "High-rise waist with classic five-pocket styling and zip fly.",
      "Tapered slightly at the ankle for a distinctive, modern shape.",
    ],
    Features: [
      "Type: balloon fit jeans",
      "Pattern: polka dot print",
      "Pockets: classic 5-pocket design",
      "Care: machine wash cold inside out",
    ],
  },
  {
    id: 1014,
    name: "Midi-dress with waist tie",
    category: "Dresses",
    price: "299.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 74,
    images: [
      "/img/1014.avif",
      "/img/1014a.avif",
      "/img/1014b.avif",
      "/img/1014c.avif",
      "/img/1014d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Flowy midi length in soft viscose with subtle twill texture.",
      "Removable waist tie allows a bow detail or relaxed fit.",
      "Button front and elastic cuffs make dressing quick for busy mornings.",
    ],
    Features: [
      "Type: midi dress with belt",
      "Details: adjustable waist tie, button placket",
      "Care: machine wash cold",
    ],
  },
  {
    id: 1015,
    name: "Halter long jumpsuit",
    category: "Jumpsuits",
    price: "259.00",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 66,
    images: [
      "/img/1015.avif",
      "/img/1015a.avif",
      "/img/1015b.avif",
      "/img/1015c.avif",
      "/img/1015d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Fluid jumpsuit with halter neckline and elastic back for comfort.",
      "Wide-leg silhouette gives room to move for parties or playdates.",
      "Side pockets and concealed zip keep the profile neat.",
    ],
    Features: [
      "Type: long halter jumpsuit",
      "Neckline: adjustable halter tie",
      "Care: machine wash delicate cycle",
    ],
  },
  {
    id: 1016,
    name: "Long dress with side slit",
    category: "Dresses",
    price: "279.00",
    country: "Mangoes Kids",
    rating: 4.6,
    reviewCount: 58,
    images: [
      "/img/1016.avif",
      "/img/1016a.avif",
      "/img/1016b.avif",
      "/img/1016c.avif",
      "/img/1016d.avif",
      "/img/1016e.avif",
    ],
    size: ["120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Maxi-length dress crafted in soft ribbed knit with gentle stretch.",
      "Side slit offers ease of movement while staying on-trend.",
      "Crew neckline and long sleeves make it a versatile layering base.",
    ],
    Features: [
      "Type: long rib dress",
      "Detail: side slit at hem",
      "Care: machine wash cold inside out",
    ],
  },
  {
    id: 1017,
    name: "Strapless maxi-dress",
    category: "Dresses",
    price: "239.00",
    country: "Mangoes Kids",
    rating: 4.4,
    reviewCount: 63,
    images: [
      "/img/1017.avif",
      "/img/1017a.avif",
      "/img/1017b.avif",
      "/img/1017c.avif",
      "/img/1017d.avif",
      "/img/1017e.avif",
      "/img/1017f.avif",
    ],
    size: ["120cm", "130cm", "140cm", "150cm"],
    description: [
      "Smocked bodice delivers a secure strapless fit ideal for summer events.",
      "Tiered skirt adds volume with lightweight cotton voile layers.",
      "Includes optional removable straps for playground-ready support.",
    ],
    Features: [
      "Type: strapless tiered maxi dress",
      "Bodice: elastic smocking",
      "Care: machine wash gentle, hang dry",
    ],
  },
  {
    id: 1018,
    name: "Lurex jacket with buttons",
    category: "Coats",
    price: "329.00",
    country: "Mangoes Kids",
    rating: 4.7,
    reviewCount: 71,
    images: [
      "/img/1018.avif",
      "/img/1018a.avif",
      "/img/1018b.avif",
      "/img/1018c.avif",
      "/img/1018d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "Sparkling lurex threads woven into a tweed-effect knit for party looks.",
      "Gold-tone crest buttons and fringe trims elevate the jacket.",
      "Soft jersey lining keeps the style comfy against the skin.",
    ],
    Features: [
      "Type: lurex tweed jacket",
      "Fastening: gold-tone buttons",
      "Care: hand wash cold",
    ],
  },
  {
    id: 1019,
    name: "Printed cotton jacket",
    category: "Coats",
    price: "269.00",
    country: "Mangoes Kids",
    rating: 4.3,
    reviewCount: 88,
    images: ["/img/1019.avif", "/img/1019a.webp", "/img/1019b.webp"],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm"],
    description: [
      "All-over floral print on breathable cotton poplin.",
      "Button placket and collar nod to classic overshirt styling.",
      "Unlined construction perfect for transitional weather layering.",
    ],
    Features: [
      "Type: printed cotton overshirt",
      "Pattern: all-over floral",
      "Care: machine wash cold, tumble dry low",
    ],
  },
  {
    id: 1020,
    name: "Faux-fur coat with buttons",
    category: "Coats",
    price: "349.00",
    country: "Mangoes Kids",
    rating: 4.8,
    reviewCount: 115,
    images: [
      "/img/1020.avif",
      "/img/1020a.avif",
      "/img/1020b.avif",
      "/img/1020c.webp",
      "/img/1020d.avif",
    ],
    size: ["110cm", "120cm", "130cm", "140cm", "150cm", "160cm"],
    description: [
      "Ultra-plush faux fur with silky lining keeps little ones snug in winter.",
      "Front button closure sized for small hands to fasten easily.",
      "Rounded collar and slightly oversized fit create a playful finish.",
    ],
    Features: [
      "Type: faux-fur coat",
      "Closure: front buttons",
      "Care: professional dry clean",
    ],
  },
  {
    id: 1021,
    name: "Crossed halter crop top",
    category: "Tops",
    price: "35.99",
    country: "Mangoes Kids",
    rating: 4.5,
    reviewCount: 115,
    images: [
      "/img/1021.avif",
      "/img/1021a.avif",
      "/img/1021b.avif",
      "/img/1021c.avif",
      "/img/1021d.avif",
    ],
    size: ["S", "M", "L"],
    description: [
      "Cotton and lyocell blend fabric.",
      "Fitted design with a cropped length.",
      "Halter neck with crossed detail at the front.",
      "Invisible side zip fastening. Total look.",
      "Designed to elevate your looks for special occasions.",
    ],
    Features: [
      "Composition: 46% lyocell, 29% linen, 25% cotton",
      "Origin: Designed in Barcelona, Manufacture in Morocco",
      "Care: Hand washing max 30°C / 85°F",
      "Care: Do not bleach",
      "Care: Ironing max 110°C / 230°F",
      "Care: Dry cleaning perchloroethylene",
      "Care: Do not tumble dry",
    ],
  },
];

export default productData;
